<ng-container *transloco="let t">
  <button mat-icon-button [matMenuTriggerFor]="userActions">
    <!-- <img
        class="w-7 h-7 rounded-full"
        crossorigin="anonymous"
        *ngIf="showAvatar && user.avatar"
        [src]="avatarPath + user.avatar"
        alt="Avatar"
      /> -->

    <mat-icon
      *ngIf="!showAvatar || !user.avatar"
      [svgIcon]="'heroicons_outline:user-circle'"
    >
    </mat-icon>

    <!-- <span
        class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
        [ngClass]="{
          'mr-px mb-px': !showAvatar || !user.avatar,
          'bg-green-500': user.status === 'online',
          'bg-amber-500': user.status === 'away',
          'bg-red-500': user.status === 'busy',
          'bg-gray-400': user.status === 'not-visible'
        }"
      ></span> -->
  </button>

  <mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
      <span class="flex flex-col leading-none">
        <span *ngIf="false">{{ t("user.singed_in_as") }}</span>

        <span class="mt-1.5 text-md font-medium">{{ user.name }}</span>
      </span>
    </button>

    <mat-divider class="my-2"></mat-divider>
    <!-- <button mat-menu-item>
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            <span>{{ t('user.profile') }}</span>
        </button> -->

    <!-- <button mat-menu-item>
            <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
            <span>{{ t('user.settings') }}</span>
        </button> -->

    <!-- <button mat-menu-item [matMenuTriggerFor]="userStatus">
            <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>
            <span>Status</span>
        </button> -->

    <!-- <mat-divider class="my-2"></mat-divider> -->

    <button mat-menu-item (click)="signOut()">
      <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'">
      </mat-icon>

      <span>{{ t("user.sign_out") }}</span>
    </button>
  </mat-menu>

  <!-- <mat-menu class="user-status-menu" #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('online')">
      <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>

      <span>{{ t("user.online") }}</span>
    </button>

    <button mat-menu-item (click)="updateUserStatus('away')">
      <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>

      <span>{{ t("user.away") }}</span>
    </button>

    <button mat-menu-item (click)="updateUserStatus('busy')">
      <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>

      <span>{{ t("user.busy") }}</span>
    </button>

    <button mat-menu-item (click)="updateUserStatus('not-visible')">
      <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>

      <span>{{ t("user.invisible") }}</span>
    </button>
  </mat-menu> -->
</ng-container>
